export interface ComparisonItem {
  titleKey: string; // Clé de traduction au lieu du texte
  cost: ComparisonValue;
  quality: ComparisonValue;
  deadline: ComparisonValue;
  flexibility: ComparisonValue;
  highlight: boolean;
}

export interface ComparisonValue {
  icon: string;
  textKey: string; // Clé de traduction au lieu du texte
  positive: boolean;
}

export interface Criterion {
  key: keyof Omit<ComparisonItem, "titleKey" | "highlight">;
  labelKey: string; // Clé de traduction au lieu du texte
}

export const comparisonData: ComparisonItem[] = [
  {
    titleKey: "options.virtuosa.title",
    cost: {
      icon: "mdi:check",
      textKey: "options.virtuosa.cost.text",
      positive: true,
    },
    quality: {
      icon: "mdi:check",
      textKey: "options.virtuosa.quality.text",
      positive: true,
    },
    deadline: {
      icon: "mdi:check",
      textKey: "options.virtuosa.deadline.text",
      positive: true,
    },
    flexibility: {
      icon: "mdi:check",
      textKey: "options.virtuosa.flexibility.text",
      positive: true,
    },
    highlight: true,
  },
  {
    titleKey: "options.fullTimeDesigner.title",
    cost: {
      icon: "mdi:close",
      textKey: "options.fullTimeDesigner.cost.text",
      positive: false,
    },
    quality: {
      icon: "mdi:close",
      textKey: "options.fullTimeDesigner.quality.text",
      positive: false,
    },
    deadline: {
      icon: "mdi:close",
      textKey: "options.fullTimeDesigner.deadline.text",
      positive: false,
    },
    flexibility: {
      icon: "mdi:close",
      textKey: "options.fullTimeDesigner.flexibility.text",
      positive: false,
    },
    highlight: false,
  },
  {
    titleKey: "options.otherAgency.title",
    cost: {
      icon: "mdi:close",
      textKey: "options.otherAgency.cost.text",
      positive: false,
    },
    quality: {
      icon: "mdi:close",
      textKey: "options.otherAgency.quality.text",
      positive: false,
    },
    deadline: {
      icon: "mdi:close",
      textKey: "options.otherAgency.deadline.text",
      positive: false,
    },
    flexibility: {
      icon: "mdi:close",
      textKey: "options.otherAgency.flexibility.text",
      positive: false,
    },
    highlight: false,
  },
];

export const criteria: Criterion[] = [
  { key: "cost", labelKey: "criteria.cost" },
  { key: "quality", labelKey: "criteria.quality" },
  { key: "deadline", labelKey: "criteria.deadline" },
  { key: "flexibility", labelKey: "criteria.flexibility" },
];
